import { combineReducers } from 'redux'
import settings from './settings'
import hru from '../containers/HealthcareUsageReport/reducers'
import pathway from '../containers/PathwayViewer/reducers'
import training from '../containers/Training/trainingSlice'
import user from '../actions/userSlice'
import storyboard from '../containers/Storyboard/storyboardSlice'
import glossary from '../containers/Glossary/glossarySlice'
import current from '../containers/CohortBuilder/cohortBuilderSlice'
import queryBuilder from '../containers/QueryBuilder/queryBuilderSlice'

// https://stackoverflow.com/questions/36786244/nested-redux-reducers

export default combineReducers({
  current,
  settings,
  user,
  hru,
  pathway,
  training,
  storyboard,
  glossary,
  queryBuilder
})